import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "../components/ui/switch";
import { errMsg, patchSettings, useDashboard, useRefresh } from "../lib/api";
import { Loading, PageHeader } from "../components/PageHeader";

const Row = ({ title, desc, children }) => (
  <div className="flex flex-wrap items-center justify-between gap-4 border-t border-slate-800 py-5 first:border-t-0">
    <div className="max-w-xl">
      <div className="text-sm font-medium text-slate-100">{title}</div>
      <div className="mt-1 text-xs leading-relaxed text-slate-500">{desc}</div>
    </div>
    {children}
  </div>
);

const TextSetting = ({ name, value, onSave }) => {
  const [v, setV] = useState(value);
  useEffect(() => { setV(value); }, [value]);
  return (
    <input data-testid={`setting-${name}`} value={v} onChange={(e) => setV(e.target.value)} onBlur={async () => { if (v !== value && !(await onSave({ [name]: v }))) setV(value); }}
      className="h-9 w-64 rounded-md border border-slate-700 bg-[#182232] px-3 text-sm outline-none focus:border-sky-500" />
  );
};

export default function SettingsPage() {
  const { data, isLoading } = useDashboard();
  const refresh = useRefresh();
  if (isLoading || !data) return <Loading />;
  const s = data.settings;
  const save = async (body) => {
    try { await patchSettings(body); await refresh(); toast.success("Settings saved"); return true; } catch (e) { toast.error(errMsg(e)); return false; }
  };
  return (
    <div data-testid="settings-page">
      <PageHeader kicker="Rules" title="Settings" />
      <section className="rise max-w-4xl rounded-lg border border-slate-800 bg-[#131b29]/80 px-6">
        <Row title="Peak season" desc="Amazon's minimum is 14 days on hand off-peak and 28 days in peak (dates in your Work Order).">
          <Switch data-testid="setting-peak-season" checked={s.peak_season} onCheckedChange={(v) => save({ peak_season: v })} />
        </Row>
        <Row title="Month-end week" desc="Amazon asks for monthly forecast and capacity figures only in the last week of each month; other weeks they export as 0.">
          <Switch data-testid="setting-month-end" checked={s.month_end} onCheckedChange={(v) => save({ month_end: v })} />
        </Row>
        <Row title="Supplier name in forecast file" desc="Only forecast lines for this supplier are loaded. If none match, every line is loaded.">
          <TextSetting name="supplier_name" value={s.supplier_name} onSave={save} />
        </Row>
        <Row title="Supplier plant" desc="City written in the supplier_plant column of the Amazon export.">
          <TextSetting name="supplier_plant" value={s.supplier_plant} onSave={save} />
        </Row>
      </section>
    </div>
  );
}
